import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';
import { Sparkles, Eye, EyeOff } from 'lucide-react';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login({ email, password });
      toast.success('Welcome back!');
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#08080A] flex items-center justify-center px-6">
      <div className="noise-overlay" />
      <div className="w-full max-w-sm animate-fade-in-up opacity-0">
        <Link to="/" className="flex items-center gap-2 mb-10" data-testid="login-logo">
          <Sparkles className="w-6 h-6 text-[#CDFE65]" />
          <span className="font-black text-xl tracking-tight" style={{ fontFamily: 'Chivo' }}>THE HUMAN</span>
        </Link>
        <h1 className="text-3xl font-black tracking-tight mb-2" style={{ fontFamily: 'Chivo' }}>Welcome back</h1>
        <p className="text-sm text-white/40 mb-8">Log in to your creative studio</p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-xs uppercase tracking-wider text-white/40 font-mono mb-1.5 block">Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="forge-input w-full" placeholder="you@company.com" required data-testid="login-email-input" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-white/40 font-mono mb-1.5 block">Password</label>
            <div className="relative">
              <input type={showPw ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} className="forge-input w-full pr-10" placeholder="Min 8 characters" required data-testid="login-password-input" />
              <button type="button" onClick={() => setShowPw(!showPw)} className="absolute right-3 top-1/2 -translate-y-1/2 text-white/30 hover:text-white/60">
                {showPw ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full text-sm" data-testid="login-submit-btn">
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        <p className="text-sm text-white/30 mt-6 text-center">
          Don't have an account? <Link to="/signup" className="text-[#CDFE65] hover:underline" data-testid="login-signup-link">Sign up</Link>
        </p>
      </div>
    </div>
  );
}
